import { defineComponent, onMounted, ref, watch } from 'vue';
import { InitGoogleAppPlugin } from 'src/plugins/google/initApiScript';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { debounceTime, filter, map, tap } from 'rxjs/operators';
import { StandardAlertsPlugin } from 'src/plugins/alert/alertPlugin';
export default defineComponent({
    name: 'webGoogleLogin',
    props: {
        label: String,
        disable: Boolean,
        scope: {
            type: String,
            default: 'email profile'
        }
    },
    emits: ['login'],
    setup(props, context) {
        // check if google is loaded
        const { googleReady } = InitGoogleAppPlugin();
        // check if google accounts is loaded
        const ready = ref(false);
        const { subject: appInitializer$ } = rxInitSubjectCallback();
        useObservable(appInitializer$.pipe(debounceTime(500), map(() => {
            if (typeof window === 'undefined') {
                return false;
            }
            if (window.google && window.google.accounts) {
                ready.value = true;
                return true;
            }
            return false;
        }), filter((v) => v === false), tap(() => {
            appInitializer$.next('');
        })));
        const { errorAlert } = StandardAlertsPlugin();
        /**
         * callback function when user logs in to google
         * @param response google token response
         */
        function tokenClientCallback(response) {
            if (!response.access_token) {
                errorAlert('Failed to login with google. Please try again or contact us if this error persists');
                return;
            }
            context.emit('login', {
                accessToken: response.access_token
            });
        }
        /**
         * When user clicks on the google login btn
         */
        function login() {
            window?.google.accounts.oauth2.initTokenClient({
                client_id: process.env.googleSignInParams,
                scope: props.scope,
                callback: tokenClientCallback
            }).requestAccessToken();
        }
        onMounted(() => {
            // check if google is loaded
            appInitializer$.next('');
            if (typeof window === 'undefined')
                return;
            // set the global params for google login
            window.tokenClientCallback = tokenClientCallback;
            window.gLogin = login;
        });
        watch(googleReady, (newValue) => {
            if (!newValue)
                return;
            // check if google is loaded
            appInitializer$.next('');
        });
        return {
            googleReady,
            ready,
            login
        };
    }
});
